// Minimal API client that attaches auth token if present

import { getAuthTokenCookie } from '../utils/authToken'

export const API_BASE = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env?.VITE_API_BASE_URL || ''

export type ApiOptions = RequestInit & { headers?: Record<string, string> }

export async function apiFetch<T = unknown>(path: string, options: ApiOptions = {}): Promise<T> {
  const token = getAuthTokenCookie()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string> | undefined) ?? {}),
  }
  if (token) headers['Authorization'] = `Bearer ${token}`

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  })

  if (!res.ok) {
    // Try to parse JSON error response first
    let errorData: unknown
    try {
      errorData = await res.json()
    } catch {
      // Fallback to text if not JSON
      const text = await res.text().catch(() => '')
      throw new Error(`API ${res.status}: ${text}`)
    }
    
    // Throw error with data attached for better handling
    const error = new Error((errorData as { error?: { message?: string }, message?: string })?.error?.message || (errorData as { message?: string })?.message || `API ${res.status}`) as Error & { status?: number; data?: unknown }
    error.status = res.status
    error.data = errorData
    throw error
  }
  // Try json, fallback to text
  try {
    return (await res.json()) as T
  } catch {
    return (await res.text()) as unknown as T
  }
}
